import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppRadio from '@nxsys/components/AppRadio';
import AppRadioGroup from '@nxsys/components/AppRadioGroup';
import { defaultContractTypeOptions } from '@nxsys/constants/AppConstants';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import clsx from 'clsx';
import React, { Ref, useImperativeHandle } from 'react';

export type ContractTypeValues = {
  contractType: string;
};

export type ContractTypeFormRef = {
  isValidForm: () => Promise<boolean>;
  getValues: () => ContractTypeValues;
  resetFields: () => void;
};

type ContractTypeFormProps = {
  formRef?: Ref<ContractTypeFormRef>;
  initialValues?: ContractTypeValues;
};

const ContractTypeForm: React.FC<ContractTypeFormProps> = ({
  formRef,
  initialValues,
}) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm<ContractTypeValues>();
  const watchValues = Form.useWatch([], form);

  useImperativeHandle(formRef, () => ({
    isValidForm: async () => {
      try {
        await form.validateFields();
        return true;
      } catch (error) {
        return false;
      }
    },
    getValues() {
      return form.getFieldsValue(true);
    },
    resetFields() {
      form.resetFields();
    },
  }));

  const onFinish: FormProps['onFinish'] = async (values) => {
    console.info('values', values);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      initialValues={{
        contractType: defaultContractTypeOptions[0].value,
        ...initialValues,
      }}
    >
      <div className="text-[18px] font-bold">
        {messages['common.contractType']}
      </div>
      <div className="text-[16px] text-gray-500 mb-[40px]">
        {messages['common.contractTypeHelperText']}
      </div>
      <Form.Item name="contractType">
        <AppRadioGroup className="flex flex-col gap-y-[16px]">
          {defaultContractTypeOptions.map((option) => (
            <div
              key={option.value}
              className={clsx(
                'border border-gray-300 rounded-[12px] p-[16px] w-[456px]',
                {
                  'border-primary-500':
                    option.value === watchValues?.contractType,
                },
              )}
            >
              <AppRadio value={option.value}>
                <div className="text-[20px] font-bold leading-none mb-[8px]">
                  {option.label}
                </div>
                <div className="text-[14px] text-gray-500">
                  {option.description}
                </div>
              </AppRadio>
            </div>
          ))}
        </AppRadioGroup>
      </Form.Item>
    </AppFormContainer>
  );
};

export default ContractTypeForm;
